import { get, post } from './axios.js'


/**
 * News&Notice 상세조회 - /nws/nwsSelect
 * @param {Object} params
 * @property {Number} params.nws_seq - News&Notice seq
 * @returns
 */
export async function nwsSelect(params = {}) {
    try {
      const result = await post('/nws/nwsSelect', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * News&Notice 등록/수정 - /nws/nwsEdit
 * @param {Object} params
 * @property {Number} params.nws_seq - News&Notice seq
 * @property {string} params.title - 게시판명
 * @property {string} params.content - 내용
 * @property {string} params.ss_user_id - 로그인 user id
 * @property {string} params.del_yn -삭제여부
 * @returns
 */
export async function nwsEdit(params = {}) {
    try {
      const result = await post('/nws/nwsEdit', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * News&Notice 목록 조회 - /nws/nwsList
 * @param {Object} params
 * @property {string} params.title - 게시판명
 * @property {string} params.content - 내용
 * @property {string} params.del_yn -삭제여부
 * @property {Number} params.page_count - page 단위
 * @property {Number} params.unit_count - 힌 페이지에 보여줄 cnt
 * @returns
 */
export async function nwsList(params = {}) {
    try {
      const result = await post('/nws/nwsList', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}

/**
 * News&Notice 삭제 - /nws/nwsDelete
 * @param {Object} params
 * @property {Number} params.nws_seq -News&Notice seq
 * @property {string} params.ss_user_id - 로그인 user id
 * @returns
 */
export async function nwsDelete(params = {}) {
    try {
      const result = await post('/nws/nwsDelete', params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}